import React from 'react'
import {PopupProps} from './types'

export const popupCloseSubscriptions: Record<string, () => void> = {}

export const PropsContext = React.createContext(
  undefined as unknown as PopupProps
)
